import React from 'react';

import { Navigate, useLocation } from 'react-router-dom';

import useSession from '../hooks/useSession'; 
import { navItems } from '../views/constituo/navItems.js';
import { navItemsMobile } from '../views/constituo/navItemsMobile.js';

export default function ProtectedRoute(props) {
	
	const location = useLocation();
	const path = location.pathname;
	const { hasRoute } = useSession();

	if (path == '/' || hasRoute(path, navItems) || hasRoute(path, navItemsMobile)) return props.children;
	else return <Navigate to="/" />
}